import api from './api';

const extractData = (data) => {
  if (data && typeof data === 'object' && data.$values) {
    return data.$values;
  }
  return data;
};

const appointmentsService = {
  // Buscar próximos horários disponíveis para agendamento
  // GET /api/appointments/next-available-slots?professionalId=&serviceId=&placeId=&count=
  getNextAvailableSlots: async (professionalId, serviceId, placeId, count = 3) => {
    const response = await api.get('/appointments/next-available-slots', {
      params: { professionalId, serviceId, placeId, count },
    });
    return extractData(response.data);
  },
};

export default appointmentsService;
